/**
 * Copyright (c) Microsoft Corporation.  All rights reserved.
 */

// WARNING: This is a generated file
//
// To re-generate this file follow these steps
// 1. Set up your .npmrc file per this url: https://microsoft.visualstudio.com/DefaultCollection/Universal%20Store/_packaging?feed=EMT.Monetization&_a=feed
//   a. Click connect to feed
//   b. Click npm
//   c. Click 'generate npm credentials, and copy to \Users\<your user name>\.npmrc file
// 2. Install emt-swagger-typescript-gen:
//   npm install -g emt-swagger-typescript-gen --registry https://microsoft.pkgs.visualstudio.com/_packaging/EMT.Monetization/npm/registry/
// 3. emt-swagger-typescript-gen --out enrollment.ts --url http://localhost:8890/swagger/v1/swagger.json
//
// Steps 1 & 2 may be skipped if you have done them before

export enum PartnerIdType {
    MPN = "MPN"
}

export enum ProfileAction {
    NotRequired = "notRequired",
    PendingPartner = "pendingPartner",
    PendingMicrosoft = "pendingMicrosoft"
}

export enum EnrollmentState {
    Unknown = "",
    Enrolling = "Enrolling",
    Enrolled = "Enrolled"
}

export enum PaymentMethod{
    Unknown = "",
    ElectronicBankTransfer = "ElectronicBankTransfer",
    CreditNote = "CreditNote",
    LRDCreditMemo = "LRDCreditMemo",
    PayPal = "PayPal"
}

export interface PartnerId {
    type: PartnerIdType;
    value: string;
}

export interface Enrollment {
    offeringId: string;
    offeringGuid: string;
    partnerId: PartnerId;
    partnerLocation: string;
    countryName: string;
    enrollmentState: EnrollmentState;
    isActive: boolean;
    accessViaLegacy: boolean;
}

export interface Invitation {
    offeringId: string;
    offeringGuid: string;
    partnerId: PartnerId;
    offeringTimelineCode: string;
    partnerLocation: string;
    countryName: string;
}

export interface PaymentAndTaxStatus {
    offeringId: string;
    partnerId: PartnerId;
    paymentInstrumentAction: ProfileAction;
    taxInstrumentAction: ProfileAction;
    taxExpired: boolean;
    taxIsExpiring: boolean;
}

export interface ReportingResponse<T> {
    value: T[],
    nextLink: string,
    totalCount: number
}

export interface Payout {
    enrollmentParticipantId: string;
    enrollmentParticipantType: string;
    programCode: string;
    payoutAmountUSD: number;
    //catpure additional parameters
    [key: string]: any;
}

export interface Earning {
    enrollmentParticipantId: string;
    enrollmentParticipantType: string;
    programCode: string;
    earningAmountUSD: number;
    //catpure additional parameters
    [key: string]: any;
}

export interface PayoutReport {
    offeringId: string;
    partnerId: PartnerId;
    totalEarned: number;
    totalPaid: number;
    currencyCode: string;
}

export interface NewEnrollmentRequest {
    partnerId: PartnerId,
    offeringId: string
}

export interface AcceptInvitationResponse {
    partnerId: PartnerId,
    offeringId: string,
    state: string
}

export interface EligibilityData {
    processingTimestamp: string,
    factors: EligibilityFactor[],
    isOverridden: boolean | null
}

export interface EligibilityFactor {
    factorName: string,
    factorDescriptionList: string[] | null,
    isFactorMet: boolean
}

export interface RoleInformationForUser {
    responseState: string,
    tableOfContacts: RoleContact[]

}

export interface RoleContact {
    displayName: string,
    userPrincipalName: string

}

export interface PartnerLocationInformation {
    partnerId: PartnerId;
    globalPartnerId: PartnerId;
    companyName?: string;
    primaryContactFirstName?: string;
    primaryContactLastName?: string;
    countryName?: string;
}

export interface DefaultPaymentProfileSelection {
    paymentMethod: PaymentMethod,
    bankProfileId: string,
    partnerId: PartnerId,
    currency: string
}

export interface BankProfileItemDetails {
    bankProfileId: string,
    profileName: string,
    bankName: string,
    accountLastFourDigits: string,
    bankCountryCode: string,
    bankCountryName: string,
    localAddressAvailable: boolean,
    localAddressRequired: boolean
}

export interface DefaultPaymentProfileAssignmentDetails {
    enableDefaultPaymentAndTax: boolean,
    partnerIdDetail: PartnerLocationInformation,
    bankProfileItemDetail: BankProfileItemDetails,
    selection: DefaultPaymentProfileSelection,
    taxProfilePartnerId: PartnerId,
    taxProfilePartnerIdInfo: PartnerLocationInformation,
    paymentProfileActionRequired: boolean,
    taxProfileCompleteForProgram: boolean,
    currencyUsable: boolean,
    userActionRequiredForCurrentDefaultSelection: boolean
}
